//@flow
import * as React from 'react';
import type {children, id, onClick} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import './Text1.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children,
  onClick?: onClick
};

const Text1 = (props: Props) => {
  return (
    <div id={props.id} className={baseClass("Text1", props.addClasses)} onClick={props.onClick}>{props.children}</div>
  );
};

export default Text1;